<div class="position-relative">
  <ngx-ui-loader [loaderId]="componentLoaderID"></ngx-ui-loader>

  @if (tableHasItems() || (!tableHasItems() && showTableIfEmpty)) {
    <div class="table-responsive">
      <table
        class="table table-head-custom table-vertical-center overflow-hidden table-row-gray-200 align-middle gy-3 gx-5 table-rounded"
        [class.table-striped]="tableHasItems() ? striped : false"
        [class.table-rounded]="rounded"
        [class.border]="bordered"
        [class.table-row-bordered]="showRowBorder"
        [class.table-dark]="darkMode"
        [class.table-row-dashed]="showRowBorderDashed"
        [class.table-flush]="flushStyles"
        [class.table-hover]="rowHoverable"
      >

        <!--<editor-fold desc="Table Header">-->
        @if (undefined === headersTemplateRef && columns && columns.length > 0) {
          <thead [ngClass]="headerClass" [ngStyle]="headerStyle">
          <tr>
            @for (header of columns; track header) {
              @if (header.enabled || undefined === header.enabled) {
                <th
                  class="fw-boldest"
                  [ngClass]="header.class || ''"
                  [ngStyle]="header.style || {}"
                  [class.cursor-pointer]="
                  undefined !==  header.config?.column
                  && 'computed_cell' !==  header.config?.column
                  && 'action_cell' !==  header.config?.column
                  && true === header.config?.sort"
                >
                  {{ header.label | translate }}

                  @if (undefined !== header.config?.column
                  && 'computed_cell' !== header.config?.column
                  && 'action_cell' !== header.config?.column
                  && true === header.config?.sort) {
                    <app-sort-icon
                      [column]="header.config?.column || 'column'"
                      [activeColumn]="sortState.column"
                      [activeDirection]="sortState.direction"
                      (sort)="sortingEmitter($event)">
                    </app-sort-icon>
                  }
                </th>
              }
            }
          </tr>
          </thead>
        } @else {
          <ng-container
            *ngTemplateOutlet="
              headersTemplateRef || defaultHeaderTemplate;
              context: { $implicit: columns, data: data() }
            "
          ></ng-container>
        }
        <!--</editor-fold>-->

        <tbody>
          @for (row of data();
            let index = $index;
            let first = $first;
            let last = $last;
            let odd = $odd;
            let even = $even;
            let count = $count;
            track trackByFn) {
            <ng-container
              *ngTemplateOutlet="
                rowTemplateRef || defaultRowTemplate;
                context: {
                $implicit: row,
                index,
                first,
                last,
                odd,
                even,
                count
              }
              "
            ></ng-container>
          } @empty {
            <ng-template [ngTemplateOutlet]="emptyTableTemplate"></ng-template>
          }
        </tbody>

        <!--<editor-fold desc="Table Footer">-->
        @if (tableHasItems() && undefined !== footerTemplateRef) {
          <tfoot>
          <tr>
            <ng-container
              *ngTemplateOutlet="footerTemplateRef;
              context: {
              $implicit: data(),
            }
            "
            ></ng-container>
          </tr>
          </tfoot>
        }
        <!--</editor-fold>-->

      </table>
    </div>
  } @else {
    <ng-template [ngTemplateOutlet]="emptyTableTemplate"></ng-template>
  }

</div>

<!--<editor-fold desc="Default Header Template">-->
<ng-template #defaultHeaderTemplate let-data="data">
  <thead [ngClass]="headerClass" [ngStyle]="headerStyle">
  <tr>
    @for (header of data[0] | keyvalue; track header.key) {
      <th>{{ $any(header.key) | titlecase }}</th>
    }
  </tr>
  </thead>
</ng-template>
<!--</editor-fold>-->

<!--<editor-fold desc="Default Row Template">-->
<ng-template #defaultRowTemplate let-row let-index="index">
  <tr>
    <ng-template #actionTemplateRef>
      @if (undefined !== rowActionTemplateRef) {
        <ng-container
          *ngTemplateOutlet="rowActionTemplateRef;context: {$implicit: row}"
        ></ng-container>
      }
    </ng-template>

    @if (undefined !== columns && columns.length > 0) {
      @for (header of columns; track header) {
        @if ((true === header.enabled || undefined === header.enabled) && undefined !== header.config) {

          @if ('action_cell' !== header.config.column) {
            <td>
              @if ('default' === header.config.cellType || undefined === header.config.cellType) {
                {{
                  undefined === header.config.cellRender
                    ? row[header.config.column]
                    : row[header.config.column] | cellTransformer: row : index : header.config.cellRender
                }}
              } @else {
                <span
                  [innerHTML]="
                  undefined === header.config.cellRender
                    ? row[header.config.column]
                    : row[header.config.column] | cellTransformer: row : index : header.config.cellRender"
                ></span>
              }
            </td>
          } @else {
            <ng-container *ngTemplateOutlet="actionTemplateRef"></ng-container>
          }

        }
      }
    } @else {
      @for (entries of row | keyvalue; track entries.key) {
        <td>{{ entries.value }}</td>
      }

      <ng-container *ngTemplateOutlet="actionTemplateRef"></ng-container>
    }

  </tr>
</ng-template>
<!--</editor-fold>-->

<!--<editor-fold desc="Empty Table Template">-->
<ng-template #noDataDefaultTemplate>
  <!--  If the user does not provide a template we use the default one -->
  @if (null === emptyTableTemplateRef || undefined === emptyTableTemplateRef) {
    <div class="d-flex flex-column align-items-center card-rounded mt-5 p-5">

      <div *ngIf="noDataShowImg" class="text-center flex-shrink-0 mb-5">
        <img width="100" ngSrc="../../../../../assets/media/svg/no_data.svg" class="" alt="no_data" height="97">
      </div>

      <div class="mb-0 fs-6">
        <div class="text-muted text-center fw-bold lh-lg mb-2" [innerText]="noDataMessage | translate"></div>
      </div>

    </div>
  } @else {
    <!--  custom template provided by user-->
    <ng-template
      [ngTemplateOutlet]="emptyTableTemplateRef"
      [ngTemplateOutletContext]="{$implicit: noDataMessage}"
    ></ng-template>
  }
</ng-template>

<ng-template #emptyTableTemplate>
  <!--showTableIfEmpty allows us to control whether we should show the table if we do not have data-->
  @if (showTableIfEmpty) {
    <tr>
      <td colspan="100">
        <ng-template [ngTemplateOutlet]="noDataDefaultTemplate"></ng-template>
      </td>
    </tr>
  } @else {
    <ng-template [ngTemplateOutlet]="noDataDefaultTemplate"></ng-template>
  }

</ng-template>
<!--</editor-fold>-->
